import Page from '../../classes/Page';
import { pageAnimations } from './pageAnimations';
// import { homeAnimations } from './homeAnimations';

const homeAltPage = new Page({
  name: 'homeAlt',
  rootElementId: 'js-page-home-alt',
  // onCreate() {
  //   console.log('homePage create')
  // },
  onInit() {
    // console.log('homePage init')

    this
      .addComponent(pageAnimations)
  },
  // onDestroy() {
  //   console.log('homePage destroy')
  // },
});

export default homeAltPage;
